import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import deepEqual from 'deep-equal';

import {navigator, router} from 'lit-element-router';
import style from '../../../../scss/seriesList.scss';
import formPageStyle from '../../../../scss/formPage.scss';
import listStyle from '../../../../scss/list.scss';
import store from '../../store';
import {
	selectCurrentContentLanguage,
	selectCurrentProfileId,
	selectLanguage,
	selectProfileSeriesLabel,
} from '../../selectors';
import {fetchSeries, selectAllSerie} from '../../slices/artworkSlice';
import getRoutes from '../../routes';
import {navigateTo} from '../../slices/statusSlice';
import plus from '../../icons/plus';
import {isPermitted} from '../../util/isPermitted';

@customElement('arc-series-list')
export class SeriesList extends connect(store)(router(navigator(LitElement))) {
	static styles = [formPageStyle, listStyle, style];
	static properties = {
		series: {type: Array},
		profileId: {type: String},

		updateNeeded: {type: Boolean}
	};

	constructor() {
		super();
		this.series = [];
		this.profileId = '';
		this.updateNeeded = false;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = selectLanguage(state);
		this.currentLanguage = selectCurrentContentLanguage(state);
		this.seriesLabel = selectProfileSeriesLabel(state);

		this.series = selectAllSerie(state);

		this.profileId = selectCurrentProfileId(state);
		this.permittedToEdit = isPermitted(['artwork/edit'], this.profileId, state);
	}

	update(changedProperties) {
		super.update(changedProperties);

		// fetch new serials list if needed, but only once
		if (this.updateNeeded) {
			this.updateNeeded = false;
			store.dispatch(fetchSeries({profileId: this.profileId}));
		}
	}

	static get routes() {
		return getRoutes();
	}

	router(route, params, query, data) {

		// check if we need to update the series list
		this.updateNeeded = route === 'series-list' &&
			(this.profileId !== params.id || !deepEqual(this.query, query));

		this.profileId = params.id;
		this.params = params;
		this.query = query;
	}

	handleAddSeries() {
		store.dispatch(navigateTo({route: 'series-create', params: this.params}));
	}

	render() {
		return html`
			<div class="formPage">

				<arc-toolbar class="toolbar">
					<div slot="left">
						<arc-breadcrumbs>
							<arc-routerlink route="artworks">${msg('Artworks')}</arc-routerlink>
							<span>${this.seriesLabel}</span>
						</arc-breadcrumbs>
						<arc-content-language-switch></arc-content-language-switch>
					</div>
					<div class="rightSlot" slot="right">
						<arc-button
							title="${msg('Add Series')}"
							type="primary"
							showLabel=${true}
							showIcon=${true}
							iconColor="ok"
							.additionalInfo="${false}"
							?disabled="${!this.permittedToEdit}"
							@click=${this.handleAddSeries}
						>${plus}</arc-button>
					</div>
				</arc-toolbar>

				<div class="list seriesList">
					${this.series.length > 0
						? html`
							<div class="listHeader">
								<div></div>
								<div>${msg('Title')}</div>
								<div>${msg('Artworks')}</div>
							</div>

							${this.series.map(
								(serie) => html`
									<div>
										<arc-series-list-item .serie=${serie}></arc-series-list-item>
									</div>
								`)}
						` : html`
							<div class="emptyMessage">${msg('No series available')}</div>`
					}
				</div>
			</div>
		`;
	}
}
